import { Grid, IconButton, Typography } from "@material-ui/core";
import { useGetRegistrosTabelaCondominioGroupPay } from "hooks/condominio/useGetRegistrosTabelaCondominioGroupPay";
import { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import CustomModal from "shared/components/modal/CustomModal";
import { RequestCondominiosPaginados } from "types/request/RequestCondominiosPaginados";
import { Col, Row } from "react-bootstrap";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";
import CustomButton from "shared/components/button/CustomButton";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { getMensagemDeErroBackend } from "shared/util/functions/errors/GetMensagemDeErroBackend";
import { possuiMensagemDeErro } from "shared/util/functions/errors/RequestPossuiMensagemDeErro";
import ModalAcessoVinculado from "./ModalAcessoVinculado";
import TabelaConfigurarCondominios from "./TabelaConfigurarCondominios";
import { ConfigurarGroupPayRequest } from "types/request/groupPay/ConfigurarGroupPayRequest";
import { usePostConfigurarGroupPayAsync } from "hooks/groupPay/usePostConfigurarGroupPayAsync";
import StandardModal from "shared/components/standardModal/StandardModal";
import showAlert from "shared/util/functions/alert/showAlert";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";

type ModalReplicarAcessoProps = {
  openModal: boolean;
  condominioJaSelecionado: number | null;
  onClose: (value: boolean) => void;
  getValues: any;
  setShowModalConfiguracaoBuscaExterna: (value: boolean) => void;
};

export type Condominio = {
  condominioId: number;
  nomeFantasia: string;
  cnpj: string;
  possuiGroupPayAtivo: boolean;
  possuiGroupPayConfigurado: boolean;
  possuiCertificadoConfigurado: boolean;
};

type FormData = {
  condominiosIds: number[] | null;
  emailPrefeitura: string | null;
  senhaPrefeitura: string | null;
};

const ModalReplicarAcesso = ({ openModal, onClose, condominioJaSelecionado, getValues, setShowModalConfiguracaoBuscaExterna }: ModalReplicarAcessoProps) => {
  const [showModalReplicar, setShowModalReplicar] = useState(false);
  const [showModalAcessoVinculado, setShowModalAcessoVinculado] = useState(false);
  const [showModalSucesso, setShowModalSucesso] = useState(false);
  const [searchCondominio, setSearchCondominio] = useState<string>("");
  const [paginaAtual, setPaginaAtual] = useState(0);
  const [sortString, setSortString] = useState<string>("");
  const [condominiosSelecionados, setCondominiosSelecionados] = useState<Condominio[]>([]);
  const [idsCondominiosSelecionados, setIdsCondominiosSelecionados] = useState<number[]>([]);
  const [isCheckBoxChecked, setIsCheckBoxChecked] = useState<boolean>(false);
  const [condominios, setCondominios] = useState<Condominio[]>([]);
  const [isReplicando, setIsReplicando] = useState(false);
  const navigate = useNavigate();
  const [successContent, setSuccessContent] = useState({
    topBar: "",
    titulo: "",
    tituloStyle: {},
    conteudoSecundario: "",
    conteudoSecundarioStyle: {},
    footerPrimaryLabel: "",
    footerSecondaryLabel: "",
    onFooterPrimaryClick: () => { },
    onFooterSecondaryClick: () => { },
  });
  const { mutateAsync } = usePostConfigurarGroupPayAsync();

  const { handleSubmit } = useForm<FormData>({
    defaultValues: {
      condominiosIds: [],
      emailPrefeitura: "",
      senhaPrefeitura: "",
    },
  });

  const params = {
    size: 99999,
    page: paginaAtual,
    sort: sortString,
    nomeCondominio: searchCondominio,
  } as RequestCondominiosPaginados;

  const { data: condominiosPaginados } = useGetRegistrosTabelaCondominioGroupPay(params);
  const queryClient = useQueryClient();

  const isDirty = idsCondominiosSelecionados.length > 0 || searchCondominio !== "";

  const loginPrefeitura = getValues("loginPrefeitura");
  const senhaPrefeitura = getValues("senhaPrefeitura");

  const fecharModal = () => {
    onClose(false);
    setCondominiosSelecionados([]);
    setIdsCondominiosSelecionados([]);
    setSearchCondominio("");
    setShowModalSucesso(false);
  }

  const handleFecharTodosModais = async () => {
    fecharModal();
    setShowModalConfiguracaoBuscaExterna(false);
    setShowModalAcessoVinculado(false)
  }

  const handleClose = () => {
    if (isDirty) {
      showAlert({
        texto: "Existem alterações que não foram salvas na tela. Tem certeza de que deseja sair sem salvar?",
        tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
        onConfirm: () => {
          fecharModal()
        },
      });
    } else {
      fecharModal()
    }
  };

  const handleOpenModalAcessoVinculado = () => {
    setShowModalAcessoVinculado(true);
    setShowModalSucesso(false);
  };

  useEffect(() => {
    if (openModal) {
      const condominiosFiltrados =
        condominiosPaginados?.content?.filter((cond: Condominio) => {
          return cond.possuiGroupPayAtivo && cond.condominioId !== condominioJaSelecionado && !cond.possuiGroupPayConfigurado;
        }) ?? [];
      setCondominios(condominiosFiltrados);
      setShowModalReplicar(true);
    } else {
      setShowModalReplicar(false);
    }
  }, [openModal, condominiosPaginados?.content, condominioJaSelecionado]);

  useEffect(() => {
    if (condominios?.length > 0 && condominiosSelecionados.length === condominios?.length) {
      setIsCheckBoxChecked(true);
    } else {
      setIsCheckBoxChecked(false);
    }
  }, [condominiosSelecionados, condominios]);

  const handleSelecionarCondominio = (condominio: Condominio) => {
    setCondominiosSelecionados((prev) => [...prev, condominio]);
    setIdsCondominiosSelecionados((prev) => [...prev, condominio.condominioId]);
  };

  const handleDesmarcarCondominio = (condominio: Condominio) => {
    setCondominiosSelecionados((prev) => prev.filter((item) => item.condominioId !== condominio.condominioId));
    setIdsCondominiosSelecionados((prev) => prev.filter((id) => id !== condominio.condominioId));
  };

  const handleMarcarEDesmarcarCondominio = (condominio: Condominio) => {
    if (idsCondominiosSelecionados.includes(condominio.condominioId)) {
      handleDesmarcarCondominio(condominio);
    } else {
      handleSelecionarCondominio(condominio);
    }
  };

  const handleSelecionarTodos = (opcao: OpcoesSelecionaveisCheckBox) => {
    if (opcao === "TODAS_PAGINA") {
      setCondominiosSelecionados(condominios ?? []);
      setIdsCondominiosSelecionados((condominios ?? []).map((cond: Condominio) => cond.condominioId));
      setIsCheckBoxChecked(true);
    } else {
      setCondominiosSelecionados([]);
      setIdsCondominiosSelecionados([]);
      setIsCheckBoxChecked(false);
    }
  };

  const onSubmit = async () => {
    setIsReplicando(true);
    const replicarAcessoCondominiosRequest = {
      condominiosIds: idsCondominiosSelecionados,
      loginPrefeitura: loginPrefeitura,
      senhaPrefeitura: senhaPrefeitura,
      permitirBuscaLancamentoNF: true,
    } as ConfigurarGroupPayRequest;

    try {
      await mutateAsync(replicarAcessoCondominiosRequest);
      await queryClient.invalidateQueries(["tabela-condominios-group-pay"]);
      setSuccessContent({
        topBar: "",
        titulo: "✅ Acesso replicado para os condomínios selecionados!",
        tituloStyle: { textAlign: "left", marginBottom: "1rem" },
        conteudoSecundario: "*A configuração individual também poderá ser realizada mais tarde.",
        conteudoSecundarioStyle: { color: "#868686", marginTop: "2rem" },
        footerPrimaryLabel: "Configurar agora",
        footerSecondaryLabel: "Configurar depois",
        onFooterPrimaryClick: () => handleOpenModalAcessoVinculado(),
        onFooterSecondaryClick: () => handleFecharTodosModais(),
      });
      setShowModalSucesso(true);

    } catch (erro) {
      if (possuiMensagemDeErro(erro)) {
        toast.error(getMensagemDeErroBackend(erro));
      }
    } finally {
      setIsReplicando(false);
    }
  };

  const Content = () => {
    return (
      <Grid container spacing={1}>
        <div style={{ marginBottom: "0.5rem" }}>
          <IconButton onClick={handleClose} size="small">
            <BsArrowLeft size={25} />
          </IconButton>
        </div>
        <Grid item xs={12}>
          <Typography variant="body2">
            <span style={{ fontWeight: "bold" }}>
              O acesso ao sistema da prefeitura informado será replicado a outros condomínios.
            </span>
            {` Certifique-se de selecionar corretamente os condomínios desejados.`}
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "1rem" }}>
          <Typography variant="body1" style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            Selecione os condomínios
          </Typography>
          <TabelaConfigurarCondominios
            condominios={condominios}
            searchCondominio={searchCondominio}
            setSearchCondominio={setSearchCondominio}
            sizeInputSearch={8}
            renderCheckbox={true}
            onSelecionarCondominio={handleMarcarEDesmarcarCondominio}
            idsSelecionados={idsCondominiosSelecionados}
            handleSelecionarTodos={handleSelecionarTodos}
            isChecked={isCheckBoxChecked}
          />
        </Grid>
      </Grid>
    );
  };

  const FooterModalReplicarAcesso = () => {
    return (
      <Row>
        <Col className="d-flex justify-content-end p-0">
          <CustomButton
            id="cancelarModal"
            label="Cancelar"
            onClick={handleClose}
            variant="danger-alt"
            className="me-2"
          />
          <CustomButton
            id="testarConexao"
            label="Replicar acesso"
            onClick={() => handleSubmit(onSubmit)()}
            variant="primary"
            className="ps-4 pe-4"
            disabled={idsCondominiosSelecionados.length === 0 || isReplicando}
          />
        </Col>
      </Row>
    );
  };

  return (
    <>
      <CustomModal
        showModal={showModalReplicar}
        titulo="Vincular acesso para outros condomínios "
        size="lg"
        onCloseModal={handleClose}
        tipoModal="MODAL_LATERAL"
        scrollable
        hideCloseButton
        customFooter={FooterModalReplicarAcesso()}
      >
        <Grid container spacing={2}>
          <Grid item style={{ marginBottom: "1rem", padding: "0.8rem" }}>
            <Content />
          </Grid>
        </Grid>
      </CustomModal>

      <ModalAcessoVinculado
        openModal={showModalAcessoVinculado}
        setShowModalAcessoVinculado={setShowModalAcessoVinculado}
        condominiosVinculados={condominiosSelecionados}
        setCondominiosSelecionados={setCondominiosSelecionados}
        setIdsCondominiosSelecionados={setIdsCondominiosSelecionados}
        setShowModalConfiguracaoBuscaExterna={setShowModalConfiguracaoBuscaExterna}
        setShowModalReplicar={setShowModalReplicar}
        loginPrefeitura={loginPrefeitura}
        senhaPrefeitura={senhaPrefeitura}
      />

      <StandardModal
        showModal={showModalSucesso}
        onCloseModal={handleClose}
        {...successContent}
        conteudoPrimario={
          <Typography>
            Todos os condomínios selecionados utilizarão os mesmos dados informados para acesso ao sistema da prefeitura.<br />
            <strong>No entanto, ainda é necessário configurar individualmente o certificado e senha para cada um dos condomínios selecionados.</strong>
          </Typography>
        }
        footerPrimaryVariant="primary"
        footerSecondaryVariant="outline-primary"
        size="sm"
        fecharModalAoClicarFora={true}
      />
    </>
  );
};

export default ModalReplicarAcesso;
